module.exports = __webpack_public_path__ + "img/ring.41f1775f.png";